module.exports = __webpack_public_path__ + "static/media/sell_make_12.640763c9.png";